import React from "react";
import BtnChiTiet from "./ChucNang/ChiTiet/BtnChiTiet";
import BtnSua from "./ChucNang/Sua/BtnSua";
import BtnXoa from "./ChucNang/Xoa/BtnXoa";

const ContentTable = ({ listDanhSach = [], phanQuyen, onReload, PageIndex = 1, PageSize = 20 }) => {
  return (
    <>
      {listDanhSach.map((item, index) => (
        <div key={item.Id} className="custom-table-row" style={{ minHeight: "56px", borderBottom: '1px solid #e0e0e0' }}>
          <div className="custom-table-cell flex-basis-5 text-left" style={{ justifyContent: 'flex-start', fontWeight: 500 }}>
            <span className="mobile-column-name color7-bold">STT</span>
            <div className="center-wrapper color7-bold">
              {index + 1 + (PageIndex - 1) * (PageSize || 20)}
            </div>
          </div>
          <div className="custom-table-cell flex-basis-70 text-center" style={{ justifyContent: 'flex-center' }}>
            <span className="mobile-column-name color7-bold">Tên hợp đồng</span>
            <div className="center-wrapper">
              {phanQuyen.xem ? <BtnChiTiet item={item} /> : item.ContractName}
            </div>
          </div>
          <div className="custom-table-cell flex-basis-25 text-left">
            <div className="center-wrapper" style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
              {phanQuyen.sua && <BtnSua item={item} onReload={onReload} />}
              {phanQuyen.xoa && <BtnXoa item={item} onReload={onReload} />}
            </div>
          </div>

        </div>
      ))}
    </>
  );
};

export default ContentTable;